<template>
    <div>
        <b-row>
            <b-col md="12" class="my-1">
                <h3 class="text-themecolor">Triggermeldingen</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <!-- User Interface controls -->
                        <b-row>
                            <b-col md="12" class="my-1">
                                <b-form-group class="mb-0">
                                    <b-input-group>
                                        <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- User Interface controls -->
    
                        <!-- Main table element -->
                        <b-row>
                            <b-col md="12">
                                <b-table class="table-hover"
                                         show-empty 
                                         :items="triggermeldingen"  
                                         :empty-text="getEmptyText(count)" 
                                         :fields="fields" 
                                         :current-page="currentPage" 
                                         :per-page="perPage" 
                                         :filter="filter"
                                         :tbody-tr-class="setTbodyTrClass" 
                                         @filtered="onFiltered"
                                         :busy="count == -1">
                                    <template v-slot:cell(actions)="row">
                                        <b-button variant="themecolor" size="m" @click="goToTriggerDetailWithMessage(row.item)">
                                            <i class="mdi mdi-file-document" aria-hidden="true"></i>
                                        </b-button>
                                        <b-button v-b-modal.modalTriggermeldingen variant="themecolor" class="ml-1" size="m" @click.stop="loadModal(row.item)">
                                            <i class="fa fa-comment" aria-hidden="true"></i>
                                        </b-button>
                                    </template>
                                    <template v-slot:cell(meldingTijd)="data">{{ data.item.meldingTijd | datetime }}</template>
                                    <template v-slot:cell(melding)="data">
                                        <div style="max-width:500px;">
                                            {{data.item.melding}}
                                       </div>
                                    </template>
                                    <template v-slot:table-busy>
                                        <PreLoader/>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <!-- Main table element -->
    
                        <!-- Pagination controls -->
                        <b-row>
                            <b-col md="12" lg="5">
                                <b-form-group label-cols :label="$t('datatables.perpagina')">
                                    <b-form-select :options="pageOptions" v-model="perPage" />
                                </b-form-group>
                            </b-col>
                            <b-col md="12" lg="7">
                                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                            </b-col>
                        </b-row>
                        <!-- Pagination controls -->
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Modal Component -->
        <b-modal id="modalTriggermeldingen" ref="triggermeldingen" :title="`Triggermelding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form @submit="onSubmit" autocomplete="off">
                <!-- Form content -->
                <h3>Melding ({{command.meldingTijd | datetime }})</h3>
                {{command.melding}}
                <hr/>
                <b>Indiener: </b> {{command.username}} <br/>
                <b>Klant:</b> {{ command.klantId}}<br/>
                <b>Document:</b> {{ command.documentId}}<br/>
                <b>Trigger:</b>
                    <router-link v-if="command.triggerId < -1" :to="{ name: 'mltriggers:detail', params: { triggerId: -command.triggerId, melding: command.melding, triggermeldingId: command.id, isFromMessage: true }}" class="nav-link mltrigger-link">{{ command.triggerId}}</router-link>
                    <div v-if="command.triggerId >= -1" class="triggerid-text">{{ command.triggerId }}</div>
                <br/>
                <br/>
                <h4>Reactie: <a :href="'mailto: ' + command.username + '?subject=Reactie op melding: ' + command.melding + '&body=' + (command.reactie != null ? command.reactie : '') + '%0A%0ABetreft document ' + command.documentId + '%0A%0A'"><i class="fa fa-envelope"></i></a></h4>
                <b-textarea id="reactie" v-model="command.reactie" type="text" />
                <!-- Form content -->
                <hr />
                <!-- Submit controls -->
                <b-row>
                    <b-col md="12">
                        <b-button @click="$refs.triggermeldingen.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                        <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <ImageCollapserExpander :image="image" />
                    </b-col>
                </b-row>                
                <!-- Submit controls -->
            </b-form>
        </b-modal>
        <!-- Modal Component -->
    </div>
</template>
    
<script>
    //Import store
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    
    //Import command
    import Command from './command'
    import PreLoader from '@/components/root/Preloader';
    import ImageCollapserExpander from '@/components/controls/ImageCollapserExpander.vue';
    import { getEmptyText } from '@/views/root/GetMessageTextHelper';
    
    export default {
        name: `triggermeldingen-index`,
        components: {PreLoader, ImageCollapserExpander},
        data() {
            return {
                command: {},
                currentPage: 1,
                perPage: 50,
                pageOptions: [50, 100, 200],
                filter: null,
                count: -1,
                image: ''
            }
        },
        computed: {
            fields() { 
                return [
                    {
                        key: 'klant.customerIdAndName',
                        label: 'Klant',
                        sortable: true
                    },
                    {
                        key: 'meldingTijd',
                        label: 'Datum',
                        sortable: true
                    },
                    {
                        key: 'melding',
                        label: 'Melding',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: this.$i18n.t('datatables.acties')
                    }
                ]
            },
            ...mapGetters ('fmmodule', ['triggermeldingen']),
        },
        methods: {
            ...mapActions('fmmodule', ['all', 'update', 'getImage']),
            onFiltered(filteredItems) {
                this.count = filteredItems.length;
                this.currentPage = 1
            },
            loadModal(item) {
                let vm = this;
                vm.$store.dispatch('errors/clearErrors');
                vm.command = new Command(item);
                this.loadImage(vm.command.filename);
            },
            setTbodyTrClass(item) {
                var classes = '';
                if (item != null && item.id == this.$route.params.triggermeldingId) { classes += 'current-trigger'}
                else if (item != null && item.triggerId < 0 && this.isValidGuid(item.document.aiRecognitionId)) { classes += 'ml-melding-new' }
                else if (item != null && item.triggerId < 0) { classes += 'ml-melding' }
                return classes;
            },
            goToTriggerDetailWithMessage(item){
                if(item.triggerId < 0 && item.document.aiRecognitionId != null)
                {
                    if (isNaN(item.document.aiRecognitionId))
                    {
                        this.$router.push({ name: `documents2:detail`, params: { documentId: item.documentId, triggerId: item.triggerId, melding: item.melding, triggermelding: item, isFromMessage: true } });    
                    }
                    else
                    {
                        window.open(`https://elis.rossum.ai/document/${item.document.aiRecognitionId}`);
                    }
                }
                else if(item.triggerId > 0)
                {
                    this.$router.push({ name: `documents:detail`, params: { documentId: item.documentId, triggerId: item.triggerId, melding: item.melding, triggermeldingId: item.id, isFromMessage: true } });
                }
                else
                {
                    alert("Er is geen link gevonden met een document")
                }          
            },
            goToMlTriggerDetailWithMessage(item){

                if(item.triggerId < -1)
                {
                    this.$router.push({ name: `mltriggers:detail`, params: { triggerId: -item.triggerId, melding: item.melding, triggermeldingId: item.id, isFromMessage: true } });
                }         
            },            
            onSubmit(event) {
                event.preventDefault();
                let vm = this;
    
                let payload = {
                    resource: 'triggermeldingen',
                    path: vm.$route.path,
                    params: vm.command
                };
    
                let action = vm.command.id ? vm.update(payload) : vm.create(payload);
                action.then(() => {
                    vm.$store.dispatch('fmmodule/all', {resource: 'triggermeldingen'});
                    vm.$refs.triggermeldingen.hide();
                })
            },
            getEmptyText,
            loadImage(filename)
            {
                var vm = this;
                vm.$store.dispatch('errors/clearErrors');
                vm.getImage(
                    {
                        resource:"images",
                        filename: filename
                    }
                    ).then((response) => {
                        this.image = response
                    })
            },  
            isValidGuid(value) {
                if (value == null || value == undefined || value === '') {
                    return false;
                }

                const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
                return typeof value === 'string' && guidRegex.test(value);
           }          
        },
        created() {
            let vm = this;
            vm.all({
                resource: 'triggermeldingen'
            })
            .then((data) => {
                vm.count = data.result.length;
            });
        },
        mounted() {
            let vm = this;
            vm.command = new Command();
        }
    }
</script>
<style>
.ml-melding {
    background: #92bbf9;
    color: black;
}
.ml-melding-new {
    background: #92dcf9;
    color: black;
}
.current-trigger{
    background: #92ffaa;
}
.mltrigger-link, .triggerid-text {
    display: inline !important;
    padding-left: 0.25rem !important;
}
</style>
    